<template>
  <div class="cardIsValidated col-lg-7" id="cardValidator">
    <div class="row field-row mb-2 align-items-center">
      <div class="col-lg-4">
        <div class="field-title">Validation Service:</div>
      </div>
      <div class="col-lg-8">
        <selectpicker v-model="newBlockClass" :options="serviceOptions" />
      </div>
    </div>
    <template v-if="newBlockClass === 'Block::CombinedValidator'">
      <div class="row field-row mb-2 align-items-center" v-for="tag in Object.keys(newOptions.services)">
        <div class="col-4">
          <div class="field-title"><span class="text-capitalize">{{ tag }}</span> Service:</div>
        </div>
        <div class="col-8">
          <selectpicker v-model="newOptions.services[tag]" :options="combinedValidatorServiceOptions" include-blank />
        </div>
      </div>
    </template>
    <div class="row field-row mb-2 align-items-center" v-else>
      <div class="col-lg-4">
        <div class="field-title">Field Validated:</div>
      </div>
      <div class="col-lg-8">
        <selectpicker v-model="newOptions.fieldValidated" :options="fieldOptions" />
      </div>
    </div>
  </div>
</template>

<script>
import selectpicker from './selectpicker';
import { getLabel } from './fieldsDescription';

export default {
  name: 'cardValidator',
  props: ['stepsObj', 'stepOptions', 'blockClass'],
  components: {
    selectpicker
  },
  data: function () {
    return {
      stepName: 'Card Is Validated',
      newBlockClass: this.blockClass,
      newOptions: {
        fieldValidated: '',
        services: {
          physical: 'TV',
          digital:  'DDP'
        }
      }
    };
  },
  computed: {
    config: function () {
      return this.stepsObj.find(step => step.stepName === 'Card Is Validated').stepOptions;
    },
    fieldOptions: function () {
      return this.config.fieldValidated.map(field => [field, getLabel(field)]);
    },
    serviceOptions: function () {
      return Object.entries(this.config.validationService);
    },
    combinedValidatorServiceOptions: function () {
      return this.config.combinedValidatorServices.map(service => [service, service]);
    },
    step: function () {
      const options = this.newBlockClass === 'Block::CombinedValidator'
        ? { services: this.newOptions.services }
        : { fieldValidated: this.newOptions.fieldValidated };
      return { blockClass: this.newBlockClass, options };
    }
  },
  mounted: function () {
    this.newBlockClass = this.blockClass;
    this.newOptions = { ...this.newOptions, ...this.stepOptions };
  }
};
</script>
